import { writable } from "svelte/store"

import type { ScheduleEventActionValidationContext } from "../action-validation-presentation"

const createDialogId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID()
  }

  return `schedule-event-action-validation-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

export type ScheduleEventActionValidationDialogEntry = {
  id: string
  issues: ScheduleEventActionValidationIssue[]
  context: ScheduleEventActionValidationContext
  resolve: (confirmed: boolean) => void
  settled: boolean
}

export const scheduleEventActionValidationDialogs = writable<
  ScheduleEventActionValidationDialogEntry[]
>([])

export const confirmScheduleEventActionIssues = (
  issues: ScheduleEventActionValidationIssue[],
  context: ScheduleEventActionValidationContext,
) =>
  new Promise<boolean>((resolve) => {
    const entry: ScheduleEventActionValidationDialogEntry = {
      id: createDialogId(),
      issues,
      context,
      resolve,
      settled: false,
    }
    scheduleEventActionValidationDialogs.update((current) => [...current, entry])
  })

export const resolveScheduleEventActionValidationDialog = (
  entry: ScheduleEventActionValidationDialogEntry,
  confirmed: boolean,
) => {
  if (entry.settled) return

  entry.settled = true
  scheduleEventActionValidationDialogs.update((current) =>
    current.filter((item) => item.id !== entry.id),
  )
  entry.resolve(confirmed)
}
